module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "sert"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pii"
    }
  }), _vm._v("THE KENNETH NEBENZAHL, JR., LECTURES IN THE HISTORY OF CARTOGRAPHY")]), _vm._v(" "), _c('p', {
    staticClass: "sers"
  }, [_vm._v("PUBLISHED IN ASSOCIATION WITH THE HERMON DUNLAP SMITH CENTER FOR THE HISTORY OF CARTOGRAPHY, THE NEWBERRY LIBRARY")]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Series Editor, James R. Akerman")]), _vm._v(" "), _c('p', {
    staticClass: "serah"
  }, [_vm._v("ALSO IN THE SERIES")]), _vm._v(" "), _c('p', {
    staticClass: "seraft"
  }, [_c('i', [_vm._v("Maps: A Historical Survey of Their Study and Collecting")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by R. A. Skelton")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Five Centuries of Map Printing")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by David Woodward")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("British Maps of Colonial America")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by William Patterson Cumming")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Mapping the American Revolutionary War")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by J. B. Harley, Barbara Bartz Petchenik, and Lawrence W. Towner")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Art and Cartography: Six Historical Essays")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("edited by David Woodward")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Monarchs, Ministers, and Maps: The Emergence of Cartography as a Tool of Government in Early Modern Europe")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("edited by David Buisseret")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Rural Images: Estate Maps in the Old and New Worlds")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("edited by David Buisseret")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Envisioning the City: Six Studies in Urban Cartography")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("edited by David Buisseret")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Cartographic Encounters: Perspectives on Native American Mapmaking and Map Use")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("edited by G. Malcolm Lewis")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("The Commerce of Cartography: Making and Marketing Maps in Eighteenth-Century France and England")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Mary Sponberg Pedley")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Cartographies of Travel and Navigation")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("edited by James R. Akerman")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("The Imperial Map: Cartography and the Mastery of Empire")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("edited by James R. Akerman")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Ancient Perspectives: Maps and Their Place in Mesopotamia, Egypt, Greece, and Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("edited by Richard J. A. Talbert")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0db3b7c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-Akerman-0003.vue
// module id = 60
// module chunks = 0